import { useState, useEffect, useCallback } from 'react'
import { appsyncQuery } from '@api/appsync-client'

const GET_ORG_ANALYTICS = `
  query GetOrgAnalytics($period: String) {
    getOrgAnalytics(period: $period) {
      period
      kpis {
        activePairs inactivePairs sessionsHeld prevSessionsHeld
        mutualPrepRate prevMutualPrepRate
        goalsOnTrackRate prevGoalsOnTrackRate
      }
      prepBreakdown { bothPrepared managerOnly reportOnly neitherPrepared }
      cadenceByManager { managerId managerName weeks heldCount totalWeeks }
      adoptionFunnel {
        pairsCreated firstSessionHeld goalSetByReport
        threeOrMoreSessions mutualPrepHalfOrMore tasksUsed
      }
      prepCardUsage { card label pct }
      goalsPerPair {
        reportId reportName managerId managerName
        totalGoals atRiskGoals achievedGoals
      }
    }
  }
`

export function useAdminAnalytics(period = '12w') {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const load = useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      const result = await appsyncQuery(GET_ORG_ANALYTICS, { period })
      setData(result.getOrgAnalytics)
    } catch (err) {
      setError(err)
    } finally {
      setLoading(false)
    }
  }, [period])

  useEffect(() => { load() }, [load])

  return { data, loading, error, reload: load }
}
